import React from "react";
import Banner from "../../components/banner/Banner";
import "./LandingPage.css";
// Main component for home page
const LandingPage = () => {
  return (
    <>
      {/* Banner Section */}
      <Banner
        className="landing-page-bg text-white"
        bannerTitle={[
          "Empowering Sustainable Farming & Biodiversity ",
          <br className="d-lg-block d-none" key={"break"}></br>,
          "by Introducing Eco-Bee for Eco-Contributor",
        ]}
        href1="/eco-contributor"
        href2="/book-demo"
        button1="Explore Eco-Bee"
        button2="Book Demo"
      />
    </>
  );
};

export default LandingPage;
